import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Utilitarios } from '../utilitarios';
import { SpinnerService } from './spinner.service';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.css']
})
export class SpinnerComponent implements OnInit {

  showSpinner = false;
  spinnerImage = "loading.svg";
  spinnerText = "";
  userReactive = false;
  userFeedbackMsg = "";
  time = false;
  duration: string = null;
  scheduler: any;

  constructor(private spinnerService: SpinnerService, private cdRef: ChangeDetectorRef) {

  }

  ngOnInit() {
    this.init();
  }

  timer(){
    let contador: number = 0;
    this.scheduler = setInterval(function(){ 
      contador+=1000;
      this.duration =  Utilitarios.millisecondsToTime(contador);
     }.bind(this), 1000);
  }

  init() {

    this.spinnerService.getSpinnerObserver().subscribe((status) => {
      this.showSpinner = status.showSpinner;
      this.spinnerImage = status.spinnerImage;
      this.spinnerText = status.spinnerText;
      this.userReactive = status.userReactive;
      this.userFeedbackMsg = status.userFeedbackMsg;
      this.time = status.time;
      this.cdRef.detectChanges();

      if(this.time)
        this.timer();
    });
  }

  userClickHandler(): void {
    this.spinnerService.resetSpinner();

    if (this.scheduler)
      clearInterval(this.scheduler);
  }
}